import styled from 'styled-components';

export const StyledBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1.6rem;
  justify-content: center;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    gap: 2.4rem;
  }

  > article {
    margin-bottom: 0;

    @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
      margin-bottom: -0.8rem;
    }

    @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
      margin-bottom: 2.2rem;
    }

    > div > p {
      color: ${({ theme }) => theme.colors.text.main};
    }
  }
`;
